import { Button, Divider, HStack, Stack, Text, useDisclosure } from '@chakra-ui/react';

import type { AssignmentFormData } from '../../../../types/assignmentTypes';
import { Plus } from '@/client/components/icons/ContinuIcons';
import TriggerObjectBanner from '../TriggerObjectBanner';
import TriggerObjectSelectionModal from '../TriggerObjectSelectionModal';
import WarmNeutralSelectionMenu from '../WarmNeutralSelectionMenu';
import { WorkflowType } from '@/client/services/api/graphql/gql/graphql';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

export default function WorkshopForm() {
  const { t } = useTranslation();
  const {
    watch,
    setValue,
    formState: { errors },
  } = useFormContext<AssignmentFormData>();

  const { isOpen, onOpen, onClose } = useDisclosure();
  const { settings } = watch();
  const { triggerObject, type } = settings;

  const hasTriggerObject = !!triggerObject?.id && !!triggerObject?.title;

  const hasError = !!errors?.settings?.triggerObject;

  const workshopOptions = [
    {
      label: t('admin.assignments.automations.workshops.registers'),
      value: WorkflowType.RegisteredWorkshop,
      onClick: () => {
        setValue('settings.type', WorkflowType.RegisteredWorkshop);
      },
    },
    {
      label: t('admin.assignments.automations.workshops.attends'),
      value: WorkflowType.AttendedWorkshop,
      onClick: () => {
        setValue('settings.type', WorkflowType.AttendedWorkshop);
      },
    },
  ];

  const getLabelFromWorkshopType = (workshopType: WorkflowType) =>
    workshopOptions.find((option) => option.value === workshopType)?.label || 'Select Workshop';

  return (
    <Stack spacing={8}>
      <WarmNeutralSelectionMenu
        label={t('admin.assignments.automations.workshopRegisteredAttended.selectWorkshopType')}
        buttonLabel={getLabelFromWorkshopType(type)}
        options={workshopOptions}
      />

      <>
        <Divider />

        <Stack>
          <Text variant="createLabel" color={hasError ? 'error' : 'baseBlack'}>
            {t('admin.assignments.automations.workshopRegisteredAttended.selectWorkshop')}
          </Text>

          {hasTriggerObject && <TriggerObjectBanner onOpen={onOpen} />}

          {!hasTriggerObject && (
            <Button
              variant="neutralDashedBorder"
              onClick={onOpen}
              borderColor={hasError ? 'error' : 'neutral.200'}
              color={hasError ? 'error' : 'neutral.400'}
            >
              <HStack>
                <Plus boxSize={3} />

                <Text>
                  {t('admin.assignments.automations.workshopRegisteredAttended.addWorkshop')}
                </Text>
              </HStack>
            </Button>
          )}
        </Stack>
      </>

      <TriggerObjectSelectionModal
        title={t('admin.assignments.automations.workshopRegisteredAttended.selectWorkshop')}
        isOpen={isOpen}
        onClose={onClose}
        workflowType={type}
        workshopsOnly
      />
    </Stack>
  );
}
